"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCsrfCode;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function getCsrfCode(value) {
  const skey = value || _jsCookie.default.get('skey') || _jsCookie.default.get('p_skey');
  if (!skey) {
    return '';
  }
  let hash = 5381;
  for (let i = 0, len = skey.length; i < len; i += 1) {
    hash += (hash << 5) + skey.charCodeAt(i);
  }
  return hash & 0x7fffffff;
}